import NotFound from '@/components/common/notFound';

export default function PageNotFound() {
  return (
    <div className="flex items-center justify-center w-screen h-screen">
      <NotFound />
    </div>
  );
}
